import { render, staticRenderFns } from "./TimelinePedido.vue?vue&type=template&id=031bf0f4&scoped=true&"
import script from "./TimelinePedido.vue?vue&type=script&lang=js&"
export * from "./TimelinePedido.vue?vue&type=script&lang=js&"
import style0 from "./TimelinePedido.vue?vue&type=style&index=0&id=031bf0f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031bf0f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardTitle,VCol,VIcon,VRow,VSlideYTransition,VTimeline,VTimelineItem})
